import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, formatINR } from "@/lib/api";
import { CheckCircle } from "lucide-react";

export default function OrderSuccess() {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  useEffect(() => {
    api.get(`/orders/${id}`).then((r) => setOrder(r.data)).catch(() => {});
  }, [id]);

  return (
    <div className="max-w-3xl mx-auto px-4 py-16 text-center" data-testid="order-success">
      <CheckCircle size={54} className="text-[#E63946] mx-auto mb-6" />
      <h1 className="font-display text-4xl md:text-5xl tracking-tighter">ORDER PLACED</h1>
      <p className="text-white/60 mt-3">Thanks for shopping with Street Auto Accessories.</p>
      {order && (
        <div className="mt-8 bg-[#111] border border-white/10 p-6 text-left">
          <div className="overline text-white/50">Order Number</div>
          <div className="font-display text-2xl mb-4">{order.order_number}</div>
          <div className="flex justify-between text-sm"><span className="text-white/60">Status</span><span>{order.order_status}</span></div>
          <div className="flex justify-between text-sm"><span className="text-white/60">Payment</span><span>{order.payment_status}</span></div>
          <div className="flex justify-between text-sm mt-2"><span className="text-white/60">Total</span><span className="font-display">{formatINR(order.total)}</span></div>
        </div>
      )}
      <div className="flex flex-wrap justify-center gap-3 mt-8">
        <Link to="/account" className="sa-btn sa-btn-outline">VIEW MY ORDERS</Link>
        <Link to="/shop" className="sa-btn sa-btn-primary">CONTINUE SHOPPING</Link>
      </div>
    </div>
  );
}
